import Flag from 'global/flag';

class Popup extends Flag {
  constructor(elems) {
    super('Newsletter Popup', elems);

    this.elems = elems;

    this.elems.popup = {
      $newsletter : document.getElementById('newsletter-popup-flag'),
    };

    this.delay  = 3000; // displays popup 3 seconds after landing
    this.check  = false;
    
    if (!localStorage.getItem('mmNewsletterPopupSeen') &&
        this.elems.popup.$newsletter) {

      this.check = true;
      setTimeout((e) => {
        super.openFlag();
      }, this.delay);

      ['scroll', 'resize'].forEach((e) => {
        window.addEventListener(e, (f) => {
          if (!this.check) return;
          this.scrollCheck();
        });
      });
    }
  }

  closeFlag() {
    super.closeFlag();

    localStorage.setItem('mmNewsletterPopupSeen', true);
    this.check = false;
  }

  scrollCheck() {
    let scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    let docHeight = document.body.scrollHeight;
    let footer    = document.getElementById('footer').clientHeight;
    let winHeight = window.innerHeight;

    let footerTop = docHeight - footer - winHeight;

    scrollTop >= footerTop ? this.elems.popup.$newsletter.classList.add('inactive') : this.elems.popup.$newsletter.classList.remove('inactive');
  }
}

export default Popup;



// WEBPACK FOOTER //
// ./app/javascript/global/popup.js